import React, { useEffect, useMemo, useState } from "react";
import { Dropdown, DropdownItem, IconContainer, MainContainer } from "./styles";
import Typography from "../../../../../../components/Typography";
import { FaCaretDown } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { enterpriseService } from "../../../../../../services/modules/enterprise";
import { EnterpriseResponse } from "../../../../../../types/enterprise";
import useEnterprise from "../../../../hooks/useEnterprise";
import { Row } from "../../../../../../themes/globalStyle";
import { IoIosArrowBack } from "react-icons/io";
import ThemeColors from "../../../../../../themes/colors";

const CompanySelection: React.FC = (): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();

  const { enterpriseState, updateState } = useEnterprise();
  let { id } = useParams();

  const [enterprises, setEnterprises] = useState<EnterpriseResponse[]>();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleSelectItem = (id: string) => {
    navigate(`/empresa/${id}`);
  };

  const fetchEnterprises = () => {
    enterpriseService.getEnterprises().then((response) => {
      setEnterprises(response);
      updateState({ selectedEnterprise: id });
    });
  };

  useEffect(() => {
    fetchEnterprises();
  }, [location.pathname]);

  const foundTitle = useMemo(
    () =>
      enterprises &&
      enterprises.filter(
        (company) => company._id === enterpriseState.selectedEnterprise
      )[0]
        ? enterprises.filter(
            (company) => company._id === enterpriseState.selectedEnterprise
          )[0].company_name
        : "",
    [enterpriseState.selectedEnterprise]
  );

  return (
    <Row style={{ marginLeft: "23rem", gap: "2rem" }}>
      <Row style={{ cursor: "pointer" }} onClick={() => navigate("/empresas")}>
        <IoIosArrowBack color={ThemeColors.Bg2100} />
        <Typography text="Empresas" size="medium" color="Bg2100" weight={600} />
      </Row>
      <MainContainer onClick={() => setIsOpen((prev) => !prev)}>
        <Typography
          text={foundTitle}
          size="medium"
          color="Black500"
          weight={600}
        />
        {isOpen && enterprises && (
          <Dropdown>
            {enterprises.map((company) => (
              <DropdownItem
                onClick={() => handleSelectItem(company._id)}
                isSelected={enterpriseState.selectedEnterprise === company._id}
              >
                <Typography
                  text={company.company_name}
                  size="small"
                  color="Black500"
                  weight={
                    enterpriseState.selectedEnterprise === company._id
                      ? 700
                      : 500
                  }
                />
              </DropdownItem>
            ))}
          </Dropdown>
        )}
        <IconContainer>
          <FaCaretDown
            style={{
              justifySelf: "flex-end",
              transform: isOpen ? "rotate(180deg)" : "none",
            }}
          />
        </IconContainer>
      </MainContainer>
    </Row>
  );
};

export default CompanySelection;
